<!--
Типы
listlight  список + удаление
list список + изменение текста + input  + удаление
full список + изменение текста + input + процент  + удаление
fullCheck список + input + check  + удаление

-->
<template>
  <div class="vl">

    <h4>{{ title }}</h4>
    <ul class="todo-list">
      <!--      <li @dragover.prevent @drop="dragFinish(-1, $event)"-->
      <!--          v-if="dragging > -1" class="trash-drop todo-item"-->
      <!--          v-bind:class="{drag: isDragging}">Удалить</li>-->
      <li v-show="type && type=='full' || type=='fullCheck' || type=='list'">
        <input :placeholder="titleinput"
               type="text" class="new-todo todo-item form-control"
               v-model="newItem" @keyup.enter="addItem">
      </li>
      <li v-show="type && type=='full'" class="row">
        <div class="col-5">Заголовок</div>
        <div class="col-4">Диапазон значений</div>
        <div class="col-2">Итоговый процент</div>
      </li>
      <li v-if="treeData && treeData.length>0"
          v-for="(item,key) in treeData"
          v-key="key"
          :class="[(item.id==id) ? 'color_li' : '']"
          class="todo-item"
          draggable="true"
          @dragstart="dragStart(key, $event)"
          @dragover.prevent @dragend="dragEnd"
          @drop="dragFinish(key, $event)">
        <div class="row" @click="clickLink(item.id)">

          <div class="col-1">
            <i class="fa fa-ellipsis-v" style="margin-top: 0.7em;"></i>
          </div>
          <div class="col-10" v-show="type=='list'">
            <input type="text" @change="nameChange(item.id,item.name)" v-model="item.name" class="form-control">
          </div>
          <div class="col-10" v-show="type=='listlight'">
            <span v-if="item.family"> {{ item.family }}</span> {{ item.name }} <span
              v-if="item.surname"> {{ item.surname }}</span>
          </div>

          <div v-show="type && type=='full'" class="col-4" >
            <input type="text" @change="nameChange(item.id,item.name)" v-model="item.name" class="form-control">
          </div>


          <div class="col-7" v-show="type!='list' && type!='listlight' && type!='full'">
          <span v-if="type &&  type=='fullCheck'">
               <input type="text" @change="nameChange(item.id,item.value)" v-model="item.value" class="form-control">
          </span>
            <span v-else>
            {{ item.name }}
          </span>
          </div>

          <div class="col-5" v-show="type=='full'">
            <div class="row" style="flex-wrap: nowrap;">
            <div class="col-5">
              <input type="number" v-model="item.percent_st" min="1" max="99"
                     class="form-control" >
            </div>
              <div class="col-1">-</div>
              <div class="col-5">
              <input type="number" v-model="item.percent_end" min="1" max="99"
                     class="form-control" >
            </div>
              <div class="col-1" style="margin-top: 6px;" @click="percentChange(item.id, item.percent_st, item.percent_end )">
<!--                <span class="remove-item" @click="removeItem(item.id)">x</span>-->
                <span class="addbtnp"  >+</span>
<!--                <span class="remove-item" @click="removeItem(item.id)">x</span>-->
              </div>
         </div>


          </div>

          <div class="col-1" v-show="type=='full'" style="margin-top: 6px;">
            <div style="text-align: right">{{item.res}}</div>
          </div>


          <div class="col-3" v-show="type!='list' && type!='listlight' && type!='full' && type!='quest'">
          <span v-if="type=='fullCheck'">
              <input type="checkbox" v-model="item.publish" @change="published(item.id,item.publish)">
          </span>
            <span v-else>
              <input type="number" @change="percentChange(item.id,item.percent)" v-model="item.percent"
                     class="form-control" min="0" max="100">
          </span>
          </div>

           <div v-show="type=='quest'" class="col-3"></div>


          <div class="col-1">
            <span class="remove-item" @click="removeItem(item.id)">x</span>
          </div>
        </div>
      </li>
    </ul>


    <div class="absolute-bg-black" v-if="is_show_win "></div>
    <div class="windowAdd" v-if="is_show_win ">
      <br>
      <div class="container">
        <input type="text" maxlength="50" class="form-control" v-model="form.name">
      </div>
      <div class="windowFoter container">
        <button @click="is_show_win=false" class="btn ">
          Закрыть
        </button>
        <button @click="is_show_win=false; add() " class="btn btn-success">
          Добавить
        </button>

      </div>
      <br>
    </div>


  </div>
</template>

<script>
const TODO_STORAGE_KEY = "todostorage";

let todoStorage = {
  fetch: () => JSON.parse(localStorage.getItem(TODO_STORAGE_KEY) || "[]"),
  save: todos => localStorage.setItem(TODO_STORAGE_KEY, JSON.stringify(todos))
};
export default {
  name: "EditListWidget",
  props: [
    'title', 'titleinput', 'type'
  ],
  data() {
    return {
      id: '',
      publish: false,
      is_show_win: false,
      form: {
        id: '',
        name: '',
        value: '',
        dist: '',
        published: '',
        percent: '',
        res: ''
      },
      treeData: [],
      todos: todoStorage.fetch(),
      newItem: "",
      dragging: -1
    }
  },
  methods: {
    addItem() {
      var app = this;
      if (!this.newItem) {
        return;
      }
      app.$emit('addItem', this.newItem);
      this.newItem = "";
    },
    removeItem(item) {
      this.$emit('deleteItem', item);
    },
    removeItemAt(index) {
      this.treeData.splice(index, 1);
    },
    dragStart(which, ev) {
      ev.dataTransfer.setData('Text', this.id);
      ev.dataTransfer.dropEffect = 'move'
      this.dragging = which;
    },
    dragEnd(ev) {
      this.dragging = -1
    },
    dragFinish(to, ev) {
      this.moveItem(this.dragging, to);
      ev.target.style.marginTop = '2px'
      ev.target.style.marginBottom = '2px'
    },
    moveItem(from, to) {
      var i;
      if (to === -1) {
        this.removeItemAt(from);
        //    this.$emit('deleteItem', item);
      } else {
        this.treeData.splice(to, 0, this.treeData.splice(from, 1)[0]);
        for (i = 0; this.treeData.length > i; i++) {
          this.treeData[i].number = i;
        }
      }
      this.$emit('moveItem', this.treeData);
    },
    nameChange(id, data) {
      var app = this;
      app.$emit('nameChange', id, data);
    },
    percentChange(id, data_st, data_end) {
      var app = this;
      console.log(id, data_st, data_end);
      app.$emit('percentChange', id, data_st, data_end);
    },
    published(id, data) {
      var app = this;
      app.$emit('published', id, data);
    },
    clickLink(id) {
      if (this.type == 'full' || this.type == 'standart' || this.type == 'list') {
        var app = this;
        this.id = id;
        app.$emit('clickLink', id);
      }
    },
    range(){
      let errors=[];
      this.form.goods_volume=this.form.goods_volume.replace(/[$.]/g, ',');
      if(!/^\s*\d*[\.\,]?\d{0,3}$/.test(this.form.goods_volume)){
        errors[0]='incorrect value';
        this.toastError(errors);
      }
    },
    data(data) {
      this.treeData = data;
    },
  },
  mounted() {
  },
  computed: {},
  watch: {}
}
</script>

<style>

.vl {
  /*border-left: 2px solid #c9ccce;*/
  /*height: auto;*/
}


.addbtnp {
  padding: 2px;
   background: rgba(0, 192, 84, 0.9);
   color: white;
   height: 22px;
   width: 22px;
   border-radius: 1em;
   text-align: center;
}

.windowFoter {
  text-align: right;
}

.new-todo {
  width: 100%;
}

.todo-list > li {
  /*margin-left: 2em;*/
  background-color: hsl(0deg 0% 100% / 75%);
  overflow: hidden;
}

.color_li {
  background-color: #e9eff9 !important;
}

.trash-drop {
  border: 2px dashed #ccc !important;
  text-align: center;
  color: #e33;
}

.trash-drop:-moz-drag-over {
  border: 2px solid red;
}

.todo-item {
  border: 1px solid #ccc;
  box-shadow: 1px 2px 2px #ccc;
}

.remove-item {
  float: right;
  color: #a45;
  opacity: 0.5;
}

.todo-item:hover .remove-item {
  opacity: 1;
}

</style>